import { DateTime } from 'luxon';

/**
 * Takes a date and returns a string representing the time difference.
 * @param date - A date to compare to the current date
 * @returns
 */
export const getTimeDifference = (date: DateTime): string => {
  const currentTime = DateTime.utc();
  const timeDifferences = currentTime.diff(date, ['months', 'days', 'hours', 'minutes', 'seconds']).toObject();

  if (timeDifferences.months !== 0) {
    return `${timeDifferences.months} ${timeDifferences.months === 1 ? 'month' : 'months'}`;
  } else if (timeDifferences.days !== 0) {
    return `${timeDifferences.days} ${timeDifferences.days === 1 ? 'day' : 'days'}`;
  } else if (timeDifferences.hours !== 0) {
    return `${timeDifferences.hours} ${timeDifferences.hours === 1 ? 'hour' : 'hours'}`;
  } else if (timeDifferences.minutes !== 0) {
    return `${timeDifferences.minutes} ${timeDifferences.minutes === 1 ? 'minute' : 'minutes'}`;
  } else {
    return 'moments';
  }
};
